export { DashboardPage } from './dashboard/page';
export { ListProjectPage } from './list-project/page';
export { NotesPage } from './notes/page';
export { ProjectDetailPage } from './project-detail/page';
export { SchedulePage } from './schedule/page';
export { ActivityPage } from './activity/page';
export { TaskPage } from './task/page';
export { FormTaskPage } from './form_task/page';
export { FormSchedulePage } from './form_schedule/page';
export { DetailSchedulePage } from './detail_schedule/page';
export { DetailTaskPage } from './detail_task/page';
export { FormNotePage } from './form_note/page';
export { FormTenderPage } from './form_tender/page';
export { ProfilePage } from './profile/page';
export { LoginPage } from './login/page';
export { AboutPage } from './about/page';
export { DetailImagePage } from './detail_image/page';
export { ListTenderSubscribersPage} from './list_subscribers/page';
export { SelectPage } from './select/page';
export { ListNotificationPage } from './list_notification/page';
export { PostTenderPage } from './post_tender/page';
export { FormPostTenderPage } from './form_post_tender/page';



// WEBPACK FOOTER //
// ./src/pages/marketing/index.ts